import React, { Component } from 'react';
import { _Alert, variable, _post, _getToken, _isLogin, _setTime } from './Function';
import SideBar from './SideBar';
import Loading from './Loading';
import Pagination from './Pagination';
import '../css/Share.css';


class Share extends Component {
    constructor() {
        super();
        this.state={ 
            loadingShow: true,
            start_year_share: '0.00',
            share_per_month: '0.00',
            share_collect: '0.00',
            is_trans: true,
            transaction: [],
            currentPage: 1,
            rowPerPage: 13
        };
        _isLogin().then( value => { 
            if ( value ) this.getShare();
        });
    }

    fallBack = (page) => {
        this.setState({ currentPage: page });
    }

    onAddTime = () => { _setTime() }

    getShare() {
        let param = { token: _getToken(), platform: variable().platform };
        _post('get.share.php', param)
        .then(res => { 
            //console.log('res', res)
            this.setState({ 
                loadingShow: false, 
                start_year_share: res.data.start_year_share, 
                share_per_month: res.data.share_per_month, 
                share_collect: res.data.share_collect,
                is_trans: (res.data.is_trans) ? true : false,
                transaction: res.data.transection
            });
            if ( res.data.responseText === 101 ) {
                localStorage.clear();
                _Alert('token_fail', '', 'แจ้งเตือน', 'พบการเข้าสู่ระบบจากอุปกรณอื่น');
            } 
        }).catch(err => { 
            this.setState({ loadingShow: false });
            _Alert('error'); 
        });
    }

    renderTransaction() {
        const { rowPerPage, currentPage, transaction } = this.state;
        const indexOfLastTodo = currentPage * rowPerPage;
        const indexOfFirstTodo = indexOfLastTodo - rowPerPage;
        const currentTodos = transaction.slice(indexOfFirstTodo, indexOfLastTodo);

        return(
            <div>
                <table className="table table-share">
                    <thead>
                        <tr>
                        <th scope="col">วันที่</th>
                        <th scope="col">เลขที่ใบเสร็จ</th>
                        <th scope="col">รายการ</th>
                        <th scope="col">งวด</th>
                        <th scope="col" className="text-center">จำนวนเงิน</th>
                        <th scope="col" className="text-center">จำนวนเงินหุ้นคงเหลือ</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            currentTodos.map((transaction, index) => (
                                <tr key={index}>
                                    <td>{transaction.payment_date}</td>
                                    <td>{transaction.bill_id}</td>
                                    <td>{transaction.detail}</td>
                                    <td>{transaction.period}</td>
                                    <td className="text-right">{transaction.share_month} บาท</td>
                                    <td className="text-right">{transaction.share_collect} บาท</td>
                                </tr>
                            ))
                        }
                    </tbody>
                </table>
                
                <div className="mobile-share-content">
                    {
                        currentTodos.map((transaction, index) => (
                            <div key={index} className={(index === 0) ? 'share-loop is-first' : 'share-loop'}>
                                <div className="share-row">
                                    <div className="share-row-first"><span className="text-title">วันที่ : </span><span className="text-desc">{transaction.payment_date}</span></div>
                                    <div className="share-row-second"><span className="text-title">เลขที่ใบเสร็จ : </span><span className="text-desc">{transaction.bill_id}</span></div>
                                </div>
                                <div className="share-row">
                                    <div className="share-row-first"><span className="text-title">รายการ : </span><span className="text-desc">{transaction.detail}</span></div>
                                    <div className="share-row-second"><span className="text-title">งวด : </span><span className="text-desc">{transaction.period}</span></div>
                                </div>
                                <div className="share-row">
                                    <div className="share-row-first"><span className="text-title">จำนวนเงิน : </span><span className="text-desc">{transaction.share_month} บาท</span></div>
                                    <div className="share-row-second"><span className="text-title">จำนวนเงินหุ้นคงเหลือ : </span><span className="text-desc">{transaction.share_collect} บาท</span></div>
                                </div>
                            </div> 
                        ))
                    }
                </div>

                { (this.state.transaction.length > this.state.rowPerPage) ? <Pagination onSelectPage={this.fallBack} rowPerPage={this.state.rowPerPage} lengths={this.state.transaction.length} /> : null }
            </div>           
        )
    }

    render() {
        return (
            <div className="fix-content content-bar-bigger" onClick={(e) => this.onAddTime()}>
                <Loading show={this.state.loadingShow} />
                <SideBar onRefresh={false} />
                <div className="content-bar">

                    <div className="card">
                        <div className="card-title">
                            <div className="card-icon"><i className="fas fa-chart-line"></i></div>
                            <div className="card-title-text">หุ้น</div>
                        </div>
                        <div className="card-content">
                            <div className="card-row">
                                <div className="start_year_share"><span className="text-title">หุ้นยกมาต้นปี : </span><span className="text-desc">{this.state.start_year_share}</span></div>
                                <div className="share_per_month"><span className="text-title">หุ้นรายเดือน : </span><span className="text-desc">{this.state.share_per_month}</span></div>
                            </div>
                            <div className="card-row">
                                <div className="start_year_share"><span className="text-title">หุ้นสะสม : </span><span className="text-desc">{this.state.share_collect}</span></div>
                            </div>
                        </div>
                    </div>

                    <div className="card">
                        <div className="card-title">
                            <div className="card-icon"><i className="fas fa-exchange-alt"></i></div>
                            <div className="card-title-text">รายการเคลื่อนไหว</div>
                        </div>
                        <div className="card-content card-share">
                            {
                                (this.state.is_trans) ?
                                    this.renderTransaction()
                                :
                                    <div className="no-data">ไม่พบรายการเคลื่อนไหว</div>
                            }
                        </div>
                    </div>
                
                </div>
            </div>
        );
    }
}

export default Share;